import { create } from "zustand"
import { persist } from "zustand/middleware"

export interface PrincipalUser {
  id: string
  email: string
  fullName: string
  isPlatformAdmin: boolean
}

export interface Membership {
  tenantId: string
  tenantSlug: string
  legalName: string
  status: string
  role: string
}

interface AuthState {
  token: string | null
  user: PrincipalUser | null
  memberships: Membership[]
  activeSlug: string | null
  setSession: (token: string, user: PrincipalUser) => void
  setMemberships: (memberships: Membership[]) => void
  setActiveSlug: (slug: string | null) => void
  logout: () => void
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      memberships: [],
      activeSlug: null,
      setSession: (token, user) => {
        // Mirror to localStorage so the api.ts fetcher can read the token without
        // pulling Zustand into the request path.
        localStorage.setItem("people.token", token)
        localStorage.setItem("people.user", JSON.stringify(user))
        set({ token, user })
      },
      setMemberships: (memberships) =>
        set((s) => ({
          memberships,
          // If no active tenant yet, pick the first membership so the user lands somewhere.
          activeSlug: s.activeSlug ?? memberships[0]?.tenantSlug ?? null,
        })),
      setActiveSlug: (activeSlug) => set({ activeSlug }),
      logout: () => {
        localStorage.removeItem("people.token")
        localStorage.removeItem("people.user")
        set({ token: null, user: null, memberships: [], activeSlug: null })
      },
    }),
    {
      name: "people.auth",
      partialize: (s) => ({ token: s.token, user: s.user, activeSlug: s.activeSlug }),
    },
  ),
)
